import Vue from "vue";
import Router from "vue-router";
Vue.use(VueRouter);
export default new Router({
  base: "medical",
  mode: "history", // history  hash
  routes: [
    /**
     * 发现页
     */
    {
      path: "/find_index",
      name: "find_index",
      component: resolve => require(["@/pages/find/find_index"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/information",
      name: "information",
      component: resolve => require(["@/pages/find/information"], resolve)
    },
    {
      path: "/information_one",
      name: "information_one",
      component: resolve => require(["@/pages/find/information_one"], resolve)
    },
    {
      path: "/information_two",
      name: "information_two",
      component: resolve => require(["@/pages/find/information_two"], resolve)
    },
    {
      path: "/information_three",
      name: "information_three",
      component: resolve => require(["@/pages/find/information_three"], resolve)
    },
    {
      path: "/information_four",
      name: "information_four",
      component: resolve => require(["@/pages/find/information_four"], resolve)
    },
    {
      path: "/information_five",
      name: "information_five",
      component: resolve => require(["@/pages/find/information_five"], resolve)
    },
    {
      path: "/information_six",
      name: "information_six",
      component: resolve => require(["@/pages/find/information_six"], resolve)
    },
    {
      path: "/activity_end",
      name: "activity_end",
      component: resolve => require(["@/pages/find/activity_end"], resolve)
    },
    {
      path: "/wrist_watch_detail",
      name: "wrist_watch_detail",
      component: resolve =>
        require(["@/pages/find/wrist_watch_detail"], resolve)
    },
    /**
     * 成员页
     */
    {
      path: "/member_index",
      name: "member_index",
      component: resolve => require(["@/pages/member/member_index"], resolve)
    },
    {
      path: "/me_member",
      name: "me_member",
      component: resolve => require(["@/pages/member/me_member"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/me_add_member",
      name: "me_add_member",
      component: resolve => require(["@/pages/member/me_add_member"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/add_group",
      name: "add_group",
      component: resolve => require(["@/pages/member/add_group"], resolve)
    },
    {
      path: "/update_group",
      name: "update_group",
      component: resolve => require(["@/pages/member/update_group"], resolve)
    },
    {
      path: "/group_details",
      name: "group_details",
      component: resolve => require(["@/pages/member/group_details"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/health_data",
      name: "health_data",
      component: resolve => require(["@/pages/member/health_data"], resolve)
      // meta: {
      //   keepAlive: true,
      // }
    },
    {
      path: "/group_ask",
      name: "group_ask",
      component: resolve => require(["@/pages/member/groupAsk"], resolve)
    },
    {
      path: "/onload",
      name: "onload",
      component: resolve => require(["@/pages/member/onload"], resolve)
    },
    {
      path: "/mycode",
      name: "mycode",
      component: resolve => require(["@/pages/member/myCode"], resolve)
    },
    {
      path: "/sharing_healthdata",
      name: "sharing_healthdata",
      component: resolve =>
        require(["@/pages/member/sharing_healthData"], resolve)
    },
    {
      path: "/healthdata_abnormal",
      name: "healthdata_abnormal",
      component: resolve =>
        require(["@/pages/member/healthdata_Abnormal"], resolve)
    },
    {
      path: "/setheart",
      name: "setheart",
      component: resolve =>
        require(["@/pages/member/set_bodydata/setHeart"], resolve)
    },
    {
      path: "/set_temperature",
      name: "set_temperature",
      component: resolve =>
        require(["@/pages/member/set_bodydata/set_temperature"], resolve)
    },
    {
      path: "/set_uric",
      name: "set_uric",
      component: resolve =>
        require(["@/pages/member/set_bodydata/set_uric"], resolve)
    },
    {
      path: "/set_sleep",
      name: "set_sleep",
      component: resolve =>
        require(["@/pages/member/set_bodydata/set_sleep"], resolve)
    },
    {
      path: "/set_fetal",
      name: "set_fetal",
      component: resolve =>
        require(["@/pages/member/set_bodydata/set_fetal"], resolve)
    },
    {
      path: "/set_bloodsugar",
      name: "set_bloodsugar",
      component: resolve =>
        require(["@/pages/member/set_bodydata/set_bloodsugar"], resolve)
    },
    {
      path: "/set_bloodpre",
      name: "set_bloodpre",
      component: resolve =>
        require(["@/pages/member/set_bodydata/set_bloodpre"], resolve)
    },
    {
      path: "/set_bloodoxy",
      name: "set_bloodoxy",
      component: resolve =>
        require(["@/pages/member/set_bodydata/set_bloodoxy"], resolve)
    },
    {
      path: "/set_bloodfat",
      name: "set_bloodfat",
      component: resolve =>
        require(["@/pages/member/set_bodydata/set_bloodfat"], resolve)
    },
    {
      path: "/pending",
      name: "pending",
      component: resolve => require(["@/pages/member/pending"], resolve)
    },
    {
      path: "/invite",
      name: "invite",
      component: resolve => require(["@/pages/member/invite"], resolve)
    },
    {
      path: "/invite_confirm",
      name: "invite_confirm",
      component: resolve => require(["@/pages/member/invite_confirm"], resolve)
    },
    {
      path: "/area_code",
      name: "area_code",
      component: resolve => require(["@/pages/member/area_code"], resolve)
    },

    /**
     * JCRing成员页(黑色主题，中文、英文、芬兰、日语、俄语)
     */
    {
      path: "/JCRing_member_index",
      name: "JCRing_member_index",
      component: resolve =>
        require(["@/pages/JCRingMember/member_index"], resolve)
    },
    {
      path: "/JCRing_me_member",
      name: "JCRing_me_member",
      component: resolve =>
        require(["@/pages/JCRingMember/me_member"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/JCRing_me_add_member",
      name: "JCRing_me_add_member",
      component: resolve =>
        require(["@/pages/JCRingMember/me_add_member"], resolve),
      meta: {
        keepAlive: true
      }
    }, 
    {
      path: "/JCRing_add_group",
      name: "JCRing_add_group",
      component: resolve => require(["@/pages/JCRingMember/add_group"], resolve)
    },
    {
      path: "/JCRing_update_group",
      name: "JCRing_update_group",
      component: resolve =>
        require(["@/pages/JCRingMember/update_group"], resolve)
    },
    {
      path: "/JCRing_group_details",
      name: "JCRing_group_details",
      component: resolve =>
        require(["@/pages/JCRingMember/group_details"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/JCRing_health_data",
      name: "JCRing_health_data",
      component: resolve =>
        require(["@/pages/JCRingMember/health_data"], resolve)
      // meta: {
      //   keepAlive: true,
      // }
    },
    {
      path: "/MP4",
      name: "MP4",
      component: resolve =>
        require(["@/pages/JCRingMember/MP4"], resolve)
      // meta: {
      //   keepAlive: true,
      // }
    },
    {
      path: "/JCRing_group_ask",
      name: "JCRing_group_ask",
      component: resolve => require(["@/pages/JCRingMember/groupAsk"], resolve)
    },
    {
      path: "/JCRing_onload",
      name: "JCRing_onload",
      component: resolve => require(["@/pages/JCRingMember/onload"], resolve)
    },
    {
      path: "/JCRing_mycode",
      name: "JCRing_mycode",
      component: resolve => require(["@/pages/JCRingMember/myCode"], resolve)
    },
    {
      path: "/JCRing_sharing_healthdata",
      name: "JCRing_sharing_healthdata",
      component: resolve =>
        require(["@/pages/JCRingMember/sharing_healthData"], resolve)
    },
    {
      path: "/JCRing_healthdata_abnormal",
      name: "JCRing_healthdata_abnormal",
      component: resolve =>
        require(["@/pages/JCRingMember/healthdata_Abnormal"], resolve)
    },
    {
      path: "/JCRing_setheart",
      name: "JCRing_setheart",
      component: resolve =>
        require(["@/pages/JCRingMember/set_bodydata/setHeart"], resolve)
    },
    {
      path: "/JCRing_set_temperature",
      name: "JCRing_set_temperature",
      component: resolve =>
        require(["@/pages/JCRingMember/set_bodydata/set_temperature"], resolve)
    },
    {
      path: "/JCRing_set_uric",
      name: "JCRing_set_uric",
      component: resolve =>
        require(["@/pages/JCRingMember/set_bodydata/set_uric"], resolve)
    },
    {
      path: "/JCRing_set_sleep",
      name: "JCRing_set_sleep",
      component: resolve =>
        require(["@/pages/JCRingMember/set_bodydata/set_sleep"], resolve)
    },
    {
      path: "/JCRing_set_fetal",
      name: "JCRing_set_fetal",
      component: resolve =>
        require(["@/pages/JCRingMember/set_bodydata/set_fetal"], resolve)
    },
    {
      path: "/JCRing_set_bloodsugar",
      name: "JCRing_set_bloodsugar",
      component: resolve =>
        require(["@/pages/JCRingMember/set_bodydata/set_bloodsugar"], resolve)
    },
    {
      path: "/JCRing_set_bloodpre",
      name: "JCRing_set_bloodpre",
      component: resolve =>
        require(["@/pages/JCRingMember/set_bodydata/set_bloodpre"], resolve)
    },
    {
      path: "/JCRing_set_bloodoxy",
      name: "JCRing_set_bloodoxy",
      component: resolve =>
        require(["@/pages/JCRingMember/set_bodydata/set_bloodoxy"], resolve)
    },

    {
      path: "/JCRing_pending",
      name: "JCRing_pending",
      component: resolve => require(["@/pages/JCRingMember/pending"], resolve)
    },
    {
      path: "/JCRing_invite",
      name: "JCRing_invite",
      component: resolve => require(["@/pages/JCRingMember/invite"], resolve)
    },
    {
      path: "/JCRing_invite_confirm",
      name: "JCRing_invite_confirm",
      component: resolve =>
        require(["@/pages/JCRingMember/invite_confirm"], resolve)
    },
    {
      path: "/JCRing_area_code",
      name: "JCRing_area_code",
      component: resolve => require(["@/pages/JCRingMember/area_code"], resolve)
    },
    {
      path: "/JCRing_QRcode",
      name: "JCRing_QRcode",
      component: resolve => require(["@/pages/JCRingMember/QRcode"], resolve)
    },
  

    /**
     * 下载页
     */
    {
      path: "/download",
      name: "download",
      component: resolve => require(["@/pages/download/download"], resolve)
    },
    /**
     * 一体机
     */
    {
      path: "/machine_index",
      name: "machine_index",
      component: resolve => require(["@/pages/machine/machine_index"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/blood_pressure",
      name: "blood_pressure",
      component: resolve => require(["@/pages/machine/blood_pressure"], resolve)
    },
    {
      path: "/blood_fat",
      name: "blood_fat",
      component: resolve => require(["@/pages/machine/blood_fat"], resolve)
    },
    {
      path: "/blood_sugar",
      name: "blood_sugar",
      component: resolve => require(["@/pages/machine/blood_sugar"], resolve)
    },
    {
      path: "/uric_acid",
      name: "uric_acid",
      component: resolve => require(["@/pages/machine/uric_acid"], resolve)
    },
    {
      path: "/set_up",
      name: "set_up",
      component: resolve => require(["@/pages/machine/set_up"], resolve)
    },
    {
      path: "/usage_method",
      name: "usage_method",
      component: resolve => require(["@/pages/machine/usage_method"], resolve)
    },
    {
      path: "/FAQ",
      name: "FAQ",
      component: resolve => require(["@/pages/machine/FAQ"], resolve)
    },
    {
      path: "/record",
      name: "record",
      component: resolve => require(["@/pages/machine/record"], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/abnormal",
      name: "abnormal",
      component: resolve => require(["@/pages/machine/abnormal"], resolve)
    },
    /**
     * 灸小白健康报告
     */
    {
      path: "/report",
      name: "report",
      component: resolve => require(["@/pages/ijoou/report"], resolve)
    },
    {
      path: "/ijoouDownload",
      name: "/ijoouDownload",
      component: resolve => require(["@/pages/ijoou/download"], resolve)
    },
    {
      path: "/guide",
      name: "/guide",
      component: resolve => require(["@/pages/ijoou/guide"], resolve)
    },
    {
      path: "/exercise",
      name: "/exercise",
      component: resolve => require(["@/pages/ijoou/exercise"], resolve)
    },
    {
      path: "/health",
      name: "/health",
      component: resolve => require(["@/pages/ijoou/health"], resolve)
    },
    {
      path: "/about",
      name: "/about",
      component: resolve => require(["@/pages/ijoou/about"], resolve)
    },
    {
      path: "/privacy",
      name: "/privacy",
      component: resolve => require(["@/pages/ijoou/privacy"], resolve)
    },

    /**
     * 用户政策和隐私协议
     */
    {
      path: "/JCHealth_user_agreement_zh",
      name: "/JCHealth_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/JCHealth/user_agreement_zh"], resolve)
    },
    {
      path: "/JCHealth_user_agreement_en",
      name: "/JCHealth_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/JCHealth/user_agreement_en"], resolve)
    },
    {
      path: "/JCHealth_privacy_policy_zh",
      name: "/JCHealth_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/JCHealth/privacy_policy_zh"], resolve)
    },
    {
      path: "/JCHealth_privacy_policy_en",
      name: "/JCHealth_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/JCHealth/privacy_policy_en"], resolve)
    },
    {
      path: "/JCLife_user_agreement_zh",
      name: "/JCLife_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/JCLife/user_agreement_zh"], resolve)
    },
    {
      path: "/JCLife_user_agreement_en",
      name: "/JCLife_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/JCLife/user_agreement_en"], resolve)
    },
    {
      path: "/JCLife_privacy_policy_zh",
      name: "/JCLife_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/JCLife/privacy_policy_zh"], resolve)
    },
    {
      path: "/JCLife_privacy_policy_en",
      name: "/JCLife_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/JCLife/privacy_policy_en"], resolve)
    },

    {
      path: "/BabyThermo_user_agreement_zh",
      name: "/BabyThermo_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/BabyThermo/user_agreement_zh"], resolve)
    },
    {
      path: "/BabyThermo_user_agreement_en",
      name: "/BabyThermo_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/BabyThermo/user_agreement_en"], resolve)
    },
    {
      path: "/BabyThermo_privacy_policy_zh",
      name: "/BabyThermo_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/BabyThermo/privacy_policy_zh"], resolve)
    },
    {
      path: "/BabyThermo_privacy_policy_en",
      name: "/BabyThermo_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/BabyThermo/privacy_policy_en"], resolve)
    },
    {
      path: "/JCWear_user_agreement_zh",
      name: "/JCWear_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/JCWear/user_agreement_zh"], resolve)
    },
    {
      path: "/JCWear_user_agreement_en",
      name: "/JCWear_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/JCWear/user_agreement_en"], resolve)
    },
    {
      path: "/JCWear_user_agreement_ko",
      name: "/JCWear_user_agreement_ko",
      component: resolve =>
        require(["@/pages/agreement/JCWear/user_agreement_ko"], resolve)
    },
    {
      path: "/JCWear_user_agreement_ja",
      name: "/JCWear_user_agreement_ja",
      component: resolve =>
        require(["@/pages/agreement/JCWear/user_agreement_ja"], resolve)
    },
    {
      path: "/JCWear_privacy_policy_zh",
      name: "/JCWear_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/JCWear/privacy_policy_zh"], resolve)
    },
    {
      path: "/JCWear_privacy_policy_ko",
      name: "/JCWear_privacy_policy_ko",
      component: resolve =>
        require(["@/pages/agreement/JCWear/privacy_policy_ko"], resolve)
    },
    {
      path: "/JCWear_privacy_policy_ja",
      name: "/JCWear_privacy_policy_ja",
      component: resolve =>
        require(["@/pages/agreement/JCWear/privacy_policy_ja"], resolve)
    },
    {
      path: "/JCWear_privacy_policy_en",
      name: "/JCWear_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/JCWear/privacy_policy_en"], resolve)
    },
    {
      path: "/JCRing_user_agreement_th",
      name: "/JCRing_user_agreement_th",
      component: resolve =>
        require(["@/pages/agreement/JCRing/user_agreement_th"], resolve)
    },
    {
      path: "/JCRing_user_agreement_zh",
      name: "/JCRing_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/JCRing/user_agreement_zh"], resolve)
    },
    {
      path: "/JCRing_user_agreement_en",
      name: "/JCRing_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/JCRing/user_agreement_en"], resolve)
    },

    {
      path: "/JCRing_user_agreement_fi",
      name: "/JCRing_user_agreement_fi",
      component: resolve =>
        require(["@/pages/agreement/JCRing/user_agreement_fi"], resolve)
    },

    {
      path: "/JCRing_user_agreement_ja",
      name: "/JCRing_user_agreement_ja",
      component: resolve =>
        require(["@/pages/agreement/JCRing/user_agreement_ja"], resolve)
    },
    {
      path: "/JCRing_privacy_policy_ja",
      name: "/JCRing_privacy_policy_ja",
      component: resolve =>
        require(["@/pages/agreement/JCRing/privacy_policy_ja"], resolve)
    },
    {
      path: "/JCRing_privacy_policy_fi",
      name: "/JCRing_privacy_policy_fi",
      component: resolve =>
        require(["@/pages/agreement/JCRing/privacy_policy_fi"], resolve)
    },

    {
      path: "/JCRing_privacy_policy_zh",
      name: "/JCRing_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/JCRing/privacy_policy_zh"], resolve)
    },
    {
      path: "/JCRing_privacy_policy_th",
      name: "/JCRing_privacy_policy_th",
      component: resolve =>
        require(["@/pages/agreement/JCRing/privacy_policy_th"], resolve)
    },

    {
      path: "/JCRing_privacy_policy_en",
      name: "/JCRing_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/JCRing/privacy_policy_en"], resolve)
    },



    {
      path: "/MyXring_privacy_policy_zh",
      name: "/MyXring_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/MyXring/privacy_policy_zh"], resolve)
    },
  {
      path: "/MyXring_privacy_policy_en",
      name: "/MyXring_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/MyXring/privacy_policy_en"], resolve)
    },

    {
      path: "/MyXring_user_agreement_zh",
      name: "/MyXring_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/MyXring/user_agreement_zh"], resolve)
    },
    {
      path: "/MyXring_user_agreement_en",
      name: "/MyXring_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/MyXring/user_agreement_en"], resolve)
    },



    {
      path: "/IBRing_user_agreement_en",
      name: "/IBRing_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/IBRing/user_agreement_en"], resolve)
    },
 {
      path: "/IBRing_user_agreement_ja",
      name: "/IBRing_user_agreement_ja",
      component: resolve =>
        require(["@/pages/agreement/IBRing/user_agreement_ja"], resolve)
    },
  {
      path: "/IBRing_privacy_policy_ja",
      name: "/IBRing_privacy_policy_ja",
      component: resolve =>
        require(["@/pages/agreement/IBRing/privacy_policy_ja"], resolve)
    },
   {
      path: "/IBRing_privacy_policy_en",
      name: "/IBRing_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/IBRing/privacy_policy_en"], resolve)
    },


    
    {
      path: "/JCFit_user_agreement_zh",
      name: "/JCFit_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/JCFit/user_agreement_zh"], resolve)
    },
    {
      path: "/JCSkip_user_agreement_en",
      name: "/JCSkip_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/JCSkip/user_agreement_en"], resolve)
    },
    {
      path: "/JCSkip_privacy_policy_zh",
      name: "/JCSkip_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/JCSkip/privacy_policy_zh"], resolve)
    },
    {
      path: "/JCSkip_privacy_policy_en",
      name: "/JCSkip_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/JCSkip/privacy_policy_en"], resolve)
    },

    {
      path: "/JCSkip_user_agreement_zh",
      name: "/JCSkip_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/JCSkip/user_agreement_zh"], resolve)
    },
    {
      path: "/JCFit_user_agreement_en",
      name: "/JCFit_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/JCFit/user_agreement_en"], resolve)
    },
    {
      path: "/JCFit_privacy_policy_zh",
      name: "/JCFit_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/JCFit/privacy_policy_zh"], resolve)
    },
    {
      path: "/JCFit_privacy_policy_en",
      name: "/JCFit_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/JCFit/privacy_policy_en"], resolve)
    },
    {
      path: "/insixLife_user_agreement_zh",
      name: "/insixLife_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/insixLife/user_agreement_zh"], resolve)
    },
    {
      path: "/insixLife_user_agreement_en",
      name: "/insixLife_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/insixLife/user_agreement_en"], resolve)
    },
    {
      path: "/insixLife_privacy_policy_zh",
      name: "/insixLife_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/insixLife/privacy_policy_zh"], resolve)
    },
    {
      path: "/insixLife_privacy_policy_en",
      name: "/insixLife_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/insixLife/privacy_policy_en"], resolve)
    },
    {
      path: "/HART_user_agreement_zh",
      name: "/HART_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/HART/user_agreement_zh"], resolve)
    },
    {
      path: "/HART_user_agreement_en",
      name: "/HART_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/HART/user_agreement_en"], resolve)
    },
    {
      path: "/HART_privacy_policy_zh",
      name: "/HART_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/HART/privacy_policy_zh"], resolve)
    },
    {
      path: "/HART_privacy_policy_en",
      name: "/HART_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/HART/privacy_policy_en"], resolve)
    },

    {
      path: "/SmartRing_user_agreement_en",
      name: "/SmartRing_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/SmartRing/user_agreement_en"], resolve)
    },

    {
      path: "/SmartRing_privacy_policy_en",
      name: "/SmartRing_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/SmartRing/privacy_policy_en"], resolve)
    },
    {
      path: "/NoiseSphere_user_agreement_zh",
      name: "/NoiseSphere_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/NoiseSphere/user_agreement_zh"], resolve)
    },
    {
      path: "/NoiseSphere_user_agreement_en",
      name: "/NoiseSphere_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/NoiseSphere/user_agreement_en"], resolve)
    },
    {
      path: "/NoiseSphere_privacy_policy_zh",
      name: "/NoiseSphere_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/NoiseSphere/privacy_policy_zh"], resolve)
    },
    {
      path: "/NoiseSphere_privacy_policy_en",
      name: "/NoiseSphere_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/NoiseSphere/privacy_policy_en"], resolve)
    },

    {
      path: "/EZSmartRing_user_agreement_en",
      name: "/EZSmartRing_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/EZSmartRing/user_agreement_en"], resolve)
    },

    {
      path: "/EZSmartRing_privacy_policy_en",
      name: "/EZSmartRing_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/EZSmartRing/privacy_policy_en"], resolve)
    },
    {
      path: "/JCVital_user_agreement_zh",
      name: "/JCVital_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/JCVital/user_agreement_zh"], resolve)
    },
    {
      path: "/JCVital_user_agreement_en",
      name: "/JCVital_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/JCVital/user_agreement_en"], resolve)
    },
    {
      path: "/JCVital_privacy_policy_zh",
      name: "/JCVital_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/JCVital/privacy_policy_zh"], resolve)
    },
    {
      path: "/JCVital_privacy_policy_en",
      name: "/JCVital_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/JCVital/privacy_policy_en"], resolve)
    },
 




    {
      path: "/Nextring_user_agreement_zh",
      name: "/Nextring_user_agreement_zh",
      component: resolve =>
        require(["@/pages/agreement/Nextring/user_agreement_zh"], resolve)
    },
    {
      path: "/Nextring_user_agreement_en",
      name: "/Nextring_user_agreement_en",
      component: resolve =>
        require(["@/pages/agreement/Nextring/user_agreement_en"], resolve)
    },

 {
    path: "/Nextring_privacy_policy_zh",
      name: "/Nextring_privacy_policy_zh",
      component: resolve =>
        require(["@/pages/agreement/Nextring/privacy_policy_zh"], resolve)
    },

    {
      path: "/Nextring_privacy_policy_en",
      name: "/Nextring_privacy_policy_en",
      component: resolve =>
        require(["@/pages/agreement/Nextring/privacy_policy_en"], resolve)
    },


  
  ],






 



  // 记录离开也面前滚动的位置，配合缓存使用
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js